<template>
    <div class="flex justify-center">
        <nav id="nav" class="w-56 relative">
            <span
                class="absolute h-10 w-full bg-white rounded-lg shadow ease-out transition-transform transition-medium"
                :style="{ transform: `translateY(calc(100% * ${selected}))` }"
            ></span>
            <ul class="relative">
                <template v-for="link in links">
                    <li v-if="link.show" :key="link.route.name">
                        <button
                            type="button"
                            @click="select(link.index)"
                            :aria-selected="selected === link.index"
                            class="py-2 px-3 w-full flex items-center focus:outline-none focus-visible:underline"
                        >
                            <i
                                :class="[selected === link.index ? 'text-indigo-500' : 'text-gray-500', link.icon]"
                                class="h-6 w-6 transition-all ease-out transition-medium"
                                style="font-size: 22px; line-height: 26px;"
                            ></i>
                            <span
                                :class="selected === link.index ? 'text-black' : 'text-gray-700'"
                                class="ml-4 text-sm font-medium transition-all ease-out transition-medium"
                            >{{ link.title }}</span>
                        </button>
                    </li>
                </template>
            </ul>
        </nav>
    </div>
</template>

<script>
export default {
    data() {
        return {
            selected: 0
        };
    },

    props: {
        links: Array
    },

    methods: {
        select(index) {
            this.selected = index;
            this.$router.push(
                this.links.find(link => link.index === index).route
            );
        }
    },

    mounted() {
        let vm = this;
        let index = 0;
        this.links.forEach(function(link) {
            if (link.show == true) {
                link.index = index;
                index++;
            }
            if (link.route.name == vm.$route.name) {
                vm.selected = link.index;
            }
        });
    }
};
</script>